// New and improved version of scrollToTarget
import { isFunction } from "@disco/disco_core";

const scrollTo = ({
	parent,
	target,
	stopAtTargetZero = false,
	onEnd = null,
}) => {
	let touched = false;

	const handleInteraction = () => {
		touched = true;
	};

	const scrollStart = () => {
		document.addEventListener("touchstart", handleInteraction);
		document.addEventListener("click", handleInteraction);
	};

	const scrollEnd = () => {
		document.removeEventListener("touchstart", handleInteraction);
		document.removeEventListener("click", handleInteraction);
		if (isFunction(onEnd)) onEnd();
	};

	const handleScrollIntoView = () => {
		if (!parent || !target) {
			return scrollEnd();
		}

		const scrollRemaining =
			target.getBoundingClientRect().top -
			parent.getBoundingClientRect().top;

		if (touched === null) {
			touched = false;
			scrollStart();
		}
		// Easy way to add easing (ease-out), time-taken to scroll = loge(D) * 10
		const speed = Math.max(Math.abs(scrollRemaining) / 10, 10);

		if (
			Math.abs(scrollRemaining) <= speed ||
			touched ||
			(stopAtTargetZero && target.getBoundingClientRect().top <= 0)
		) {
			return scrollEnd();
		}

		parent.scrollTop =
			parent.scrollTop + (scrollRemaining > 0 ? 1 : -1) * speed;
		window.requestAnimationFrame(handleScrollIntoView);
	};
	handleScrollIntoView();
	touched = null;
};

export default scrollTo;
